import { apiClient } from "./apiClient";

import type {
  CategoriesListData,
  CategoriesQuery,
  CategoriesTreeData,
  CategoryDetailsData,
  CategoryItemData,
  CreateCategoryInput,
  DeleteCategoryData,
  UpdateCategoryInput,
} from "../types/categories.types";

function buildCategoriesQuery(
  query: CategoriesQuery = {},
): string {
  const params =
    new URLSearchParams();

  if (query.search?.trim()) {
    params.set(
      "search",
      query.search.trim(),
    );
  }

  if (query.type) {
    params.set(
      "type",
      query.type,
    );
  }

  if (query.level !== undefined) {
    params.set(
      "level",
      String(query.level),
    );
  }

  if (query.parentId !== undefined) {
    if (query.parentId === null) {
      params.set(
        "parentId",
        "",
      );
    } else if (query.parentId.trim()) {
      params.set(
        "parentId",
        query.parentId.trim(),
      );
    }
  }

  if (query.isActive !== undefined) {
    params.set(
      "isActive",
      String(query.isActive),
    );
  }

  if (query.sort) {
    params.set(
      "sort",
      query.sort,
    );
  }

  if (query.cursor?.trim()) {
    params.set(
      "cursor",
      query.cursor.trim(),
    );
  }

  if (query.limit !== undefined) {
    params.set(
      "limit",
      String(query.limit),
    );
  }

  const queryString =
    params.toString();

  return queryString
    ? `/categories?${queryString}`
    : "/categories";
}

export const categoriesApi = {
  list(
    query: CategoriesQuery = {},
  ) {
    return apiClient.get<CategoriesListData>(
      buildCategoriesQuery(query),
    );
  },

  tree() {
    return apiClient.get<CategoriesTreeData>(
      "/categories/tree",
    );
  },

  getById(
    categoryId: string,
  ) {
    return apiClient.get<CategoryDetailsData>(
      `/categories/${encodeURIComponent(
        categoryId,
      )}`,
    );
  },

  create(
    input: CreateCategoryInput,
  ) {
    return apiClient.post<CategoryItemData>(
      "/categories",
      input,
    );
  },

  update(
    categoryId: string,
    input: UpdateCategoryInput,
  ) {
    return apiClient.patch<CategoryItemData>(
      `/categories/${encodeURIComponent(
        categoryId,
      )}`,
      input,
    );
  },

  delete(
    categoryId: string,
  ) {
    return apiClient.delete<DeleteCategoryData>(
      `/categories/${encodeURIComponent(
        categoryId,
      )}`,
    );
  },
};